import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSdkQuery } from '@/provider';
import { SummaryController, SummaryWidgetData } from '../types';

export type SummaryWidgetSelector = (
  value: SummaryWidgetData[]
) => SummaryWidgetData | null;

export type UseSummaryControllerProps = {
  reference: string;
  selectSummary?: SummaryWidgetSelector;
  onReceiveFeedback?: (value: number) => void;
};

const DEFAULT_SELECT_SUMMARY: SummaryWidgetSelector = (value) =>
  value[0] || null;

export function useSummaryController(
  props: UseSummaryControllerProps
): SummaryController {
  const {
    reference,
    onReceiveFeedback = () => {},
    selectSummary = DEFAULT_SELECT_SUMMARY,
  } = props;

  const [feedbackValue, setFeedbackValue] = useState(0);

  const summaries = useSdkQuery(`summary-${reference}`, async (sdk) => {
    return sdk.summary.getByReference(reference);
  });

  const selectedSummary = useMemo(
    () => (summaries.data ? selectSummary(summaries.data) : null),
    [summaries, selectSummary]
  );

  const summary = useMemo(
    () => selectedSummary && { ...selectedSummary, feedback: feedbackValue },
    [selectedSummary, feedbackValue]
  );

  const setFeedback = useCallback(
    (value: number) => {
      if (summary) {
        // const prevValue = summary.feedback;
        // optimistic update the feedback value
        setFeedbackValue(value);
        onReceiveFeedback(value);
        // send the feedback on the next tick
        // setTimeout(() => {
        //   dp.setFeedback('resource', data.id, value)
        //     // when the request completes execute the success callback
        //     .then(() => {
        //       onReceiveFeedback(value);
        //     })
        //     // eventually catch any error and restore the original value
        //     .catch(() => {
        //       setFeedbackValue(prevValue);
        //     });
        // }, 0);
      }
    },
    [summary, onReceiveFeedback]
  );

  // restore the feedback value when data changes
  useEffect(() => {
    setFeedbackValue(summary?.feedback || 0);
  }, [summary]);

  return { data: summary, loading: summaries.loading, setFeedback };
}
